import { render, staticRenderFns } from "./LayoutPage.vue?vue&type=template&id=c49a8580&scoped=true&"
import script from "./LayoutPage.vue?vue&type=script&lang=js&"
export * from "./LayoutPage.vue?vue&type=script&lang=js&"
import style0 from "./LayoutPage.vue?vue&type=style&index=0&id=c49a8580&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c49a8580",
  null
  
)

export default component.exports